import { take, call } from 'redux-saga/effects'
import { apiSaga } from './sagas'
import { callApi } from '../../api/api'

// ------------------------------------
// Action Types & Creators
// ------------------------------------
export const CHECK_PIGGYBANK_STATUS =
  'foodsby/featureToggles/CHECK_PIGGYBANK_STATUS'
export const CHECK_PIGGYBANK_STATUS_SUCCESS =
  'foodsby/featureToggles/CHECK_PIGGYBANK_STATUS_SUCCESS'
export const CHECK_PIGGYBANK_STATUS_FAILURE =
  'foodsby/featureToggles/CHECK_PIGGYBANK_STATUS_FAILURE'

export const checkPiggybankStatusStart = locationId => ({
  type: CHECK_PIGGYBANK_STATUS,
  payload: { locationId }
})

export const checkPiggybankStatusSuccess = response => ({
  type: CHECK_PIGGYBANK_STATUS_SUCCESS,
  payload: { response }
})

export const checkPiggybankStatusFailure = error => ({
  type: CHECK_PIGGYBANK_STATUS_FAILURE,
  error
})

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [CHECK_PIGGYBANK_STATUS]: state => ({
    ...state,
    isCheckingStatus: true,
    piggybankStatus: undefined
  }),
  [CHECK_PIGGYBANK_STATUS_SUCCESS]: (state, action) => ({
    ...state,
    isCheckingStatus: false,
    piggybankStatus: action.payload.response
  }),
  [CHECK_PIGGYBANK_STATUS_FAILURE]: (state, action) => ({
    ...state,
    isCheckingStatus: false,
    piggybankStatus: undefined,
    piggybankError: action.error
  })
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}

export default function featureToggles(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

// ------------------------------------
// Sagas
// ------------------------------------

export function* watchCheckPiggybankStatus() {
  while (true) {
    let {
      payload: { locationId }
    } = yield take(CHECK_PIGGYBANK_STATUS)
    yield call(
      apiSaga,
      piggybankStatus,
      [locationId],
      checkPiggybankStatusSuccess,
      checkPiggybankStatusFailure
    )
  }
}

// ------------------------------------
// APIs
// ------------------------------------

export const piggybankStatus = locationId =>
  callApi.get(
    `/api/v1/achievements/piggy-bank-enabled?locationId=${locationId}`
  )
